import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { userApi } from "../../api/user-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import Info from "./components/info";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function GJIdCard() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [type, setType] = useState(true);
  const { t: translate } = useTranslation();

  const loadUserInfoData = async () => {
    const data = await userApi.userInfo();
    if (data.ok) {
      setUserInfo(data.data);
    }
  };

  const sendCardsc = async (authData) => {
    const data = await userApi.cardsc({
      cardsc: authData.cardsc,
      uid: authData.id,
    });
    if (data.ok) {
      setUserInfo(data.data);
      navigate(-1);
    }
    Toast.show({ content: data.msg });
    loadUserInfoData();
  };
  useEffect(() => {
    loadUserInfoData();
  }, []);
  return (
    <div className="min-h-screen bg-neutral-900 text-neutral-100">
      <AcendexLayout
        theme="light"
        hideBottomBar
        mobileTopBarTitle={translate(getText("高级認證"))}
        pcTopBarTitle={translate(getText("高级認證"))}
      >
        <div className="max-w-md mx-auto px-4 py-6">
          <div className="bg-neutral-800 rounded-xl shadow-card mb-6 overflow-hidden">
            <div className="border-b border-neutral-700 p-4">
              <h2 className="text-xl font-medium text-primary-light">
                {translate(getText("高级認證"))}
              </h2>
            </div>
            <Info userInfo={userInfo} sendCardsc={sendCardsc} />
          </div>

          <div className="bg-neutral-800 rounded-xl shadow-card p-4 text-sm text-neutral-300">
            <h3 className="text-base font-medium text-primary-light mb-2">
              {translate(getText("认证说明"))}
            </h3>
            <p className="mb-3 opacity-80">
              {translate(
                getText(
                  "提交身份證正反面、手持人臉識別必要清晰、照片符合標準JPG格式。系統採用曠視，證合一，避免了用戶身份信息被盜用等人工幹預的情況，平臺務必保管用戶交易賬戶資金的安全性。溫馨提示："
                )
              )}
            </p>
            <ul className="space-y-1 opacity-90">
              <li>1. {translate(getText("在驗證期間請確保網絡通暢"))}</li>
              <li>2. {translate(getText("確保不會被安全軟件攔截"))}</li>
              <li>
                3. {translate(getText("同步手機時間，確保時間與當地時區一致"))}
              </li>
              <li>4. {translate(getText("請勿佩戴眼鏡、帽子"))}</li>
              <li>5. {translate(getText("請在光線充足的環境進行驗證"))}</li>
              <li>
                6.{" "}
                {translate(getText("使用手機驗證請關閉手機的美顏、修圖等功能"))}
              </li>
            </ul>
          </div>
        </div>
      </AcendexLayout>
    </div>
  );
}
